export enum CourtSystemParams {
  CourtSystemId = 'courtSystemId',
  CourthouseId = 'courthouseId',
  CourtroomId = 'courtroomId',
  TurnaroundId = 'turnaroundId',
  YearMonth = 'yearMonth',
  Forbidden = 'forbidden',
}

export enum CourtSystemPaths {
  Admin = 'settings',
  AudioOrders = 'audio-orders',
  AcceptUseConditions = 'accept-use-conditions',
  Cases = 'cases',
  Departments = 'departments',
  DirectUpload = 'direct-upload',
  Forbidden = 'forbidden',
  JoinCourtroom = 'join-detail',
  Judges = 'judges',
  Locations = 'locations',
  MfaRequired = 'mfa-required',
  Order = 'order',
  Search = 'search',
  TranscriptOrders = 'transcript-orders',
  RealTimeHearings = 'real-time-hearings',
  CourtMonitoring = 'court-monitoring',
  RealTimeOrders = 'real-time-orders',
  RecordingPlayback = 'recording-playback',
  Recordings = 'recordings',
  Reports = 'reports',
  RecordingRequests = 'recording-requests',
  LicenseInformation = 'license-information',
}
